import * as yup from 'yup'
import { LOCATION_INVALID, TYPE_REQUIRED } from 'constants/errors'
import { zipCodeSchema } from 'helpers/schemaHelpers'

export default yup.object().shape({
  address1: yup.string().required(TYPE_REQUIRED),
  address2: yup.string(),
  city: yup.mixed().required(LOCATION_INVALID).test(
    'location-check', LOCATION_INVALID, (val: any) => Boolean(val && val.value)
  ).typeError(LOCATION_INVALID),
  zip5: zipCodeSchema,
  purchased_at: yup.mixed().required(TYPE_REQUIRED),
  estimated_value: yup.mixed().required(TYPE_REQUIRED),
})
